module.exports = __webpack_public_path__ + "static/media/pr-16.72fb3c91.jpeg";